import { ExpeditionTabContentV2 } from "./ExpeditionTabContentV2";
import { ExpeditionTabFilterV2 } from "./ExpeditionTabFilterV2";
import { ExpeditionTabRowV2 } from "./ExpeditionTabRowV2";
import { ExpeditionTabSidebar } from "./ExpeditionTabSidebar";
import { ExpeditionTabImpl } from "./ExpeditionTabV2.context";

export const ExpeditionTabV2 = Object.assign(ExpeditionTabImpl, {
  Row: ExpeditionTabRowV2,
  Content: ExpeditionTabContentV2,
  Filter: ExpeditionTabFilterV2,
  Sidebar: ExpeditionTabSidebar,
  displayName: "ExpeditionTabV2"
});
